var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.proTypedialogVisible,
            title: _vm.title,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.proTypedialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间类型：", prop: "roomTypeId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { disabled: _vm.isdisable, placeholder: "请选择" },
                      model: {
                        value: _vm.form.roomTypeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roomTypeId", $$v)
                        },
                        expression: "form.roomTypeId",
                      },
                    },
                    _vm._l(_vm.roomTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.roomTypeName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "房号数组：", prop: "roomNumbers" } },
                [
                  _c("keyword", {
                    staticClass: "from-ipt-width",
                    attrs: { labelarr: _vm.labelarr },
                    on: { getLabelarr: _vm.getLabelarr },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "数量：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.count,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "count", $$v)
                      },
                      expression: "form.count",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isdisable
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.proTypedialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }